import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tile notification-tile is-parent is-vertical is-8" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "subtitle" }

interface Props {
    title: string
    subTitle: string
    show?: boolean
    className?: string
    iconName?: string
    iconSize?: string
    transitionName?: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Alert',
  props: {
    title: null,
    subTitle: null,
    show: { type: Boolean, default: true },
    className: { default: 'is-primary' },
    iconName: { default: 'info-circle' },
    iconSize: { default: '2x' },
    transitionName: { default: 'rubber-band' }
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      appear: "",
      name: __props.transitionName
    }, {
      default: _withCtx(() => [
        (__props.show)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['notification tile is-child', __props.className])
            }, [
              _createElementVNode("div", null, [
                _createVNode(_component_font_awesome_icon, {
                  size: __props.iconSize,
                  icon: __props.iconName
                }, null, 8, ["size", "icon"]),
                _createElementVNode("span", _hoisted_2, _toDisplayString(__props.title), 1)
              ]),
              _createElementVNode("p", _hoisted_3, _toDisplayString(__props.subTitle), 1)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["name"])
  ]))
}
}

})